export const urlAssets = 'https://cms.travelfactory.fr/frontend/assets'

export const BASE_URLS = {
  auth: process.env.NODE_ENV === 'production' ? 'https://api-migdal.travelfactory.fr/cms' : 'http://localhost:8001/dev',
  menuManager: process.env.NODE_ENV === 'production' ? 'https://api-migdal.travelfactory.fr/cms' : 'http://localhost:8002/dev',
  company: process.env.NODE_ENV === 'production' ? 'https://api-migdal.travelfactory.fr/cms' : 'https://api-migdal.travelfactory.fr/cms',
  seo: process.env.NODE_ENV === 'production' ? 'https://api-migdal.travelfactory.fr/cms' : 'http://localhost:8004/dev',
  pageCRUD: process.env.NODE_ENV === 'production' ? 'https://api-migdal.travelfactory.fr/cms/CMS-CRUD' : 'http://localhost:8006/dev',
  unbounce: process.env.NODE_ENV === 'production' ? 'https://api-migdal.travelfactory.fr/cms' : 'http://localhost:8007/dev',
  swipePage: process.env.NODE_ENV === 'production' ? 'https://api-migdal.travelfactory.fr/cms' : 'http://localhost:8008/dev',
  travelFactoryFr: 'https://www.travelski.com',
  travelFactoryNl: 'https://www.nl.travelski.com',
  travelFactoryUk: 'https://www.uk.travelski.com',
  travelFactoryB2B: 'https://cse.travelski.com',
  seoImagePath: 'https://migdal.travelski.com/labui/v1/core/img/',
  travelSkiBaseUrl: 'https://migdal.travelski.com/labui/v1',
}

const endpoints = {
  auth: {
    createUser: `${BASE_URLS.auth}/auth/create-user`,
    login: `${BASE_URLS.auth}/auth/login`,
    logout: `${BASE_URLS.auth}/auth/logout`,
    refresh: `${BASE_URLS.auth}/auth/refresh`,
  },
  menuManager: {
    getMenuManager: `${BASE_URLS.menuManager}/menu`,
    getFileStructure: `${BASE_URLS.menuManager}/menu/directories`,
    updateMenu: `${BASE_URLS.menuManager}/menu/update`,
    uploadImage:
      'https://onfth86fb7.execute-api.eu-west-3.amazonaws.com/dev/image_uploader',
    pageGenerator:
      process.env.NODE_ENV === 'production'
        ? 'https://api-migdal.travelfactory.fr/cms/pageGenerator' //'https://sf467jbrv1.execute-api.eu-west-3.amazonaws.com/default/pageGenerator'
        : 'http://localhost:8005/dev/default/pageGenerator',
    deployWebsite:
      process.env.NODE_ENV === 'production'
        ? 'https://api-migdal.travelfactory.fr/cms/generate-website-pages' //'https://sf467jbrv1.execute-api.eu-west-3.amazonaws.com/default/pageGenerator'
        : 'http://localhost:8006/dev/default/CMS-CRUD',
  },
  b2b: {
    newPage:
      process.env.NODE_ENV === 'production'
        ? 'https://api-migdal.travelfactory.fr/cms/pageGenerator' //'https://sf467jbrv1.execute-api.eu-west-3.amazonaws.com/default/pageGenerator'
        : 'http://localhost:8005/dev/default/pageGenerator',
    deployPage:
      process.env.NODE_ENV === 'production'
        ? 'https://api-migdal.travelfactory.fr/cms/CMS-CRUD' //'https://sf467jbrv1.execute-api.eu-west-3.amazonaws.com/default/pageGenerator'
        : 'http://localhost:8006/dev/default/CMS-CRUD',
    // process.env.NODE_ENV === 'production'
    //     ? 'https://api-migdal.travelfactory.fr/cms/pageGenerator' //'https://sf467jbrv1.execute-api.eu-west-3.amazonaws.com/default/pageGenerator'
    //     : 'http://localhost:8005/dev/default/pageGenerator',
    liveEditor:
      process.env.NODE_ENV === 'production'
        ? 'https://api-migdal.travelfactory.fr/cms/pageGenerator' //'https://sf467jbrv1.execute-api.eu-west-3.amazonaws.com/default/pageGenerator'
        : 'http://localhost:5500/',
    newPageData:
      process.env.NODE_ENV === 'production'
        ? BASE_URLS.pageCRUD
        : `http://localhost:8006/dev/default/CMS-CRUD`,
    singleCompany: `${BASE_URLS.company}/company/single-company`,
    companies: `${BASE_URLS.company}/company/companies`,
  },
  menuConfig:
    process.env.NODE_ENV === 'production'
      ? 'https://0ykjvb8z2d.execute-api.eu-west-3.amazonaws.com/Prod/config'
      : 'http://localhost:8008/dev/Prod/config',
  seo: {
    getRobots: `${BASE_URLS.seo}/seo`,
    updateRobotsAndSitemaps: `${BASE_URLS.seo}/seo/robots`,
    getSitemaps: `${BASE_URLS.seo}/seo/sitemaps`,
    getDevSitemaps: `${BASE_URLS.seo}/seo/dev-sitemaps`,
    travelFactoryFr: BASE_URLS.travelFactoryFr,
    travelFactoryNl: BASE_URLS.travelFactoryNl,
    travelFactoryUk: BASE_URLS.travelFactoryUk,
    imagePath: BASE_URLS.seoImagePath,
  },
  requester: {
    travelSkiMoel: `${BASE_URLS.travelSkiBaseUrl}/moel-ws/moel/v1`,
    getAllCriteias: `${BASE_URLS.travelSkiBaseUrl}/se-ws/se/v1/criteria/manual/all`,
    getAllRequesters: `${BASE_URLS.travelSkiBaseUrl}/moel-ws/moel/v1/requester/all`,
    getAllCountires: `${BASE_URLS.travelSkiBaseUrl}/content-ws/content/v1/ws/language/countries`,
    getRequestFields: `${BASE_URLS.travelSkiBaseUrl}/moel-ws/moel/v1/requester/searchable/fields`,
  },
  silo: {
    getAllSilos: `${BASE_URLS.travelSkiBaseUrl}/silo-ws/silo/v1/silo`,
    getAllSearchEngines: `${BASE_URLS.travelSkiBaseUrl}/se-ws/se/v1/engine/list/fr`,
    getAllRootPages: `${BASE_URLS.travelSkiBaseUrl}/cms-ws/cms/v1/ws/page/all/filter`,
    getModelList: `${BASE_URLS.travelSkiBaseUrl}/cms-ws/cms/v1/ws/model/all`,
    getCounters: `${BASE_URLS.travelSkiBaseUrl}/silo-ws/silo/v1/generator/request`,
    hasGeneratedPages: `${BASE_URLS.travelSkiBaseUrl}/silo-ws/silo/v1/silo`,
    imagePath: BASE_URLS.seoImagePath,
    getDataTypes: `${BASE_URLS.travelSkiBaseUrl}/cms-ws/cms/v1/ws/dataSources/dataTypes`,
  },
  swipePage: {
    publish: `${BASE_URLS.pageCRUD}/swipe-page/publish`,
    checkExistence: `${BASE_URLS.swipePage}/swipe-page/check-existence`,
  },
  pageMeta:
    process.env.NODE_ENV === 'production'
      ? 'https://api-migdal.travelfactory.fr/cms/pagemeta'
      : 'http://localhost:8022/pagemeta',
  stations:  'https://4l25pjuyk47rmyxsievqslzlsa0xiayt.lambda-url.eu-west-3.on.aws/places/stations'
}

export default endpoints
